<template>
  <label :class="classes" v-bind="$attrs"><slot></slot></label>
</template>

<script>
export default {
  name: "M4Label",
  props: {
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      let classes = ["label"];
      if (this.error) {
        classes.push("label--error");
      }
      return classes;
    }
  }
};
</script>
